require("dotenv").config();
export const apiConfig = {
  apiURL_ECOM: process.env.REACT_APP_API_URL_ECOM,
  name: process.env.REACT_APP_STORE_NAME,
  indexStoreID: process.env.REACT_APP_GTM_INDEX_STORE_ID,
};

export default apiConfig;
